import React from 'react'
import { BrowserRouter, Route, Redirect } from "react-router-dom";
import SignatureScreen from './components/Signature/SignatureScreen'
import Login from './pages/login'
import Dashboard from './pages/dashboard'
import { isAuthenticated } from './utils/Utils'
import Documentos from './pages/documentos';
import Cadastrar from './pages/cadastro'
import Auth from './pages/signatario/auth'
import DocumentScreen from './components/Signature/DocumentScreen'
import ConfigScreen from './pages/config'
import CrudScreen from './pages/crud'
import Relatorio from './pages/relatorio'

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={props =>
        isAuthenticated() ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
        )
      }
    />
);

const PrivateRouteLogin = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      !isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: "/documentos", state: { from: props.location } }} />
      )
    }
  />
);

const Router = () => {
    return (
        <BrowserRouter>
            <PrivateRouteLogin path="/" exact component={Login} />
            {/* <PrivateRouteLogin path="/cadastrar" exact component={Cadastrar} /> */}
            <PrivateRouteLogin path="/login" exact component={Login} />
            {/* <PrivateRoute path="/dashboard" exact component={Dashboard} /> */}
            <PrivateRoute path="/documentos" exact component={Documentos} />
            <PrivateRoute path="/assinatura" exact component={SignatureScreen} />
            <PrivateRoute path="/config" exact component={ConfigScreen} />
            <PrivateRoute path="/config/dashboard/:tipo" exact component={CrudScreen} />
            <PrivateRoute path="/config/admin/relatorio" exact component={Relatorio} />

            <Route path="/signatario/:id" exact component={Auth}></Route>
            <Route path="/signatario/documento/:id" exact component={DocumentScreen}></Route>
        </BrowserRouter>
    )
}

export default Router